import { toast } from "react-toastify";
import { callApi } from "../../../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../../../ApiHelper/ApiUrl";
import { useEffect, useState } from "react";
import { Spinner } from "reactstrap";
import { useForm } from "react-hook-form";
import ViewDocumentModal from "../../../../Sites/ViewDocumentModal";
import { useNavigate } from "react-router-dom";
import ConfirmModal from "../../../../../components/comman/ConfirmModal";

export default function EmployeeDocuments({
  locationData,
  pageStatesMain,
  setPageStatesMain,
  redirectToProfile,
}) {
  const { handleSubmit, register, watch, setValue } = useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [existingDocuments, setExistingDocuments] = useState([]);
  const [newDocuments, setNewDocuments] = useState([]);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [modal, setModal] = useState(false);
  const toggleModal = () => {
    setModal(!modal);
  };
  const navigate = useNavigate();
  const [confirmModal, setConfirmModal] = useState(false);
  const toggleConfirmModal = () => setConfirmModal(!confirmModal);
  const [selectedId, setSelectedId] = useState("");

  // Initialize existing documents from locationData
  useEffect(() => {
    if (locationData?.documents?.length > 0) {
      setExistingDocuments(locationData.documents);
    }
  }, [locationData]);

  // Add new document
  const addDocument = () => {
    const selectedDocument = watch("documentType");
    if (
      selectedDocument &&
      !newDocuments.some((doc) => doc[selectedDocument]) &&
      !existingDocuments.some((doc) => doc.name === selectedDocument)
    ) {
      setNewDocuments((prev) => [...prev, { [selectedDocument]: null }]);
      setValue("documentType", ""); // Reset dropdown
    }
  };

  const handleFileChange = (key, file, event) => {
    if (file && file.size > 6 * 1024 * 1024) {
      toast.error("File size must be less than 6MB");
      if (event) event.target.value = "";
      return;
    }
    setNewDocuments((prev) =>
      prev.map((doc) => (doc[key] !== undefined ? { [key]: file } : doc))
    );
  };

  const removeNewDocument = (key) => {
    setNewDocuments((prev) => prev.filter((doc) => !doc.hasOwnProperty(key)));
  };

  // Delete an existing document via API
  const handleDeleteDocument = () => {
    const API = `${apiUrl.delete_document}?documentId=${selectedId}`;
    callApi(API, { method: "GET" }).then((response) => {
      toggleConfirmModal();
      if (response?.status === true) {
        setExistingDocuments((prev) =>
          prev.filter((doc) => doc.id !== selectedId)
        );
        toast.success(response.message);
      } else {
        toast.error(response.message);
      }
    });
  };

  const ActionHandler = (id) => {
    setSelectedId(id);
    toggleConfirmModal();
  };

  const handleDocumentClick = (item) => {
     const docUrl = {
      url: item?.url,
    };
    setSelectedDocument(docUrl);
    setModal(true);
  };

  const onSubmit = () => {
    const invalidDocuments = newDocuments?.some((doc) => {
      return Object.values(doc).includes(null);
    });
    if (invalidDocuments) {
      toast.error("Please select file for Document");
      return;
    }

    const formData = new FormData();
    newDocuments.forEach((doc) => {
      const [key, file] = Object.entries(doc)[0];
      if (file) {
        formData.append(key, file);
      }
    });

    const API = `${apiUrl.add_documents}?userId=${
      locationData?.id || pageStatesMain?.Id_onCreateEmp
    }`;

    setIsLoading(true);
    callApi(API, { method: "POST", form_data: formData }).then((response) => {
      setIsLoading(false);
      if (response?.status === true) {
        toast.success(response.message);
        if (redirectToProfile === true) {
          navigate(-1);
        } else {
          setPageStatesMain((prev) => ({
            ...prev,
            activeTab: 9,
          }));
        }
      } else {
        toast.error(response.message);
      }
    });
  };

  // console.log("newDocs>>>>>>>>>>.",newDocuments);

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="row">
          <div className="col-12">
            <h4 className="fs-3 rajdhani-semibold my-4 border-bottom pb-3">
              Documents
            </h4>
          </div>

          {/* Document Selector */}
          <div className="col-12 col-md-6 col-lg-4">
            <div className="form-group mb-3">
              <label htmlFor="documentType" className="form-label">
                Select Documents
              </label>
              <select
                className="form-select form-control"
                {...register("documentType")}
              >
                <option value="" className="d-none">
                  Select Documents
                </option>
                {[
                  "Pan_Card",
                  "Aadhar_Card",
                  "Mark_Sheet_10th",
                  "Mark_Sheet_12th",
                  "Character_Certificate",
                  "Experience_Letter",
                  "Pay_Slip",
                  "Pass_Book",
                  "Cancelled_Cheque",
                  "ITI_Diploma",
                  "B.Tech",
                  "Electrical_license",
                  "Other_Education",
                ].map((doc) => (
                  <option
                    key={doc}
                    value={doc}
                    disabled={
                      newDocuments.some((d) => Object.keys(d)[0] === doc) ||
                      existingDocuments.some((d) => d.name === doc)
                    }
                  >
                    {doc.replace(/_/g, " ")}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="col-12 col-md-6 col-lg-4 align-self-end">
            <div className="form-group mb-3">
              <button
                className="btn btn-outline-primary px-4"
                type="button"
                onClick={addDocument}
              >
                Add
              </button>
            </div>
          </div>
        </div>

        {/* Existing Documents */}
        <div className="row">
          {existingDocuments?.map((doc) => (
            <div
              key={doc.id}
              className="col-12 col-md-6 col-lg-4 mt-3 mb-5 d-flex justify-content-between align-items-center"
            >
              <h4
                className="mb-3"
                role="button"
                title="View Document"
                onClick={() => handleDocumentClick(doc)}
              >
                {doc.name.replace(/_/g, " ")}
              </h4>

              <button
                type="button"
                className="btn btn-sm btn-danger"
                onClick={() => ActionHandler(doc.id)}
              >
                Delete
              </button>
            </div>
          ))}
        </div>

        {/* New Documents */}
        <div className="row">
          {newDocuments.map((doc, index) => {
            const key = Object.keys(doc)[0];
            return (
              <div key={key} className="col-12 col-md-6 col-lg-4 mb-3 ">
                <div className="d-flex justify-content-between align-items-center mb-3 mt-3">
                  <h4 className="mb-3 ">{key.replace(/_/g, " ")}</h4>
                  <button
                    type="button"
                    className="btn btn-sm btn-danger"
                    onClick={() => removeNewDocument(key)}
                  >
                    Delete
                  </button>
                </div>
                <div className="img-uploader">
                  <input
                    type="file"
                    accept=".pdf"
                    className="form-control"
                    onChange={(e) => handleFileChange(key, e.target.files[0], e)}
                  />
                </div>
              </div>
            );
          })}
        </div>

        {/* Submit Button */}
        <div className="d-flex align-items-center justify-content-end">
          <button className="btn btn-primary px-4" type="submit">
            {isLoading ? <Spinner /> : "Save and Continue"}
          </button>
        </div>
      </form>
      <ViewDocumentModal
        modal={modal}
        toggle={toggleModal}
        selectedDocument={selectedDocument}
      />
      <ConfirmModal
        modal={confirmModal}
        toggle={toggleConfirmModal}
        submitHandler={handleDeleteDocument}
        isLoading={isLoading}
      />
    </>
  );
}
